import React, { useState, useEffect } from 'react'
import { Segmented } from 'antd'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Inverter: React.FC = () => {
  const { t } = useTranslation()
  const [pageSelector, setPageSelector] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setPageSelector(location.pathname.split('/')[5])
  }, [location])

  const [segmentedOptions, setSegmentedOptions] = useState<{ label: string; value: string }[]>([])
  useEffect(() => {
    setSegmentedOptions([
      { label: t('device.pv'), value: 'solar' },
      { label: t('site.grid'), value: 'grid' },
      { label: t('device.load'), value: 'load' },
      { label: t('site.battery'), value: 'battery' },
      { label: t('site.gen'), value: 'gen' },
      { label: t('device.basic'), value: 'basic' },
      { label: t('device.setting'), value: 'setting' },
    ])
  }, [t])

  return (
    <div id='inverter'>
      <div className='inverter-segmented'>
        <Segmented
          value={pageSelector}
          options={segmentedOptions}
          onChange={(value) => navigate(`${value}`)}
          size='large'
        />
      </div>
      <div className='inverter-content'>
        <Outlet />
      </div>
    </div>
  )
}

export default Inverter
